// @flow

// A status's icon, everywhere the agenda shows one: the calendar's events, the Android cards and the appointment form
export const STATUS_ICONS = {
  arrived: 'event_seat',
  confirmed: 'event_available',
  completed: 'done',
  missed: 'event_busy',
  canceled: 'highlight_off',
};
